import { FunctionComponent } from 'react';

export const NavButtons: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => <></>;
